// extracted by mini-css-extract-plugin
export default {"svgcontainer":"SvgContainer_svgcontainer__bm3fO","svg":"SvgContainer_svg__3b-No"};